import { createContext, type ReactNode, useContext } from "react";
import { findTimestamps } from "./timestamps";

/** Moves the video panel to a second. Null while no video is loaded, and times stay plain text. */
export const VideoSeek = createContext<((seconds: number) => void) | null>(null);

function Timestamp({ label, seconds }: { label: string; seconds: number }) {
	const seek = useContext(VideoSeek);
	if (!seek) return <>{label}</>;
	return (
		<button type="button" className="timestamp" title="跳转到此时刻" onClick={() => seek(seconds)}>
			{label}
		</button>
	);
}

/** Where the video stood when a message was sent, drawn in place of the watching line. */
export function WatchingChip({ label, seconds }: { label: string; seconds: number }) {
	const seek = useContext(VideoSeek);
	if (!seek) return <span className="watching-chip">⏸ {label}</span>;
	return (
		<button type="button" className="watching-chip" title="跳转到提问时刻" onClick={() => seek(seconds)}>
			⏸ {label}
		</button>
	);
}

/** A run of plain text with its `[MM:SS]` times made into seek buttons. */
export function withTimestamps(text: string, keyPrefix: string): ReactNode[] {
	const out: ReactNode[] = [];
	let last = 0;
	findTimestamps(text).forEach((t, i) => {
		if (t.start > last) out.push(text.slice(last, t.start));
		out.push(<Timestamp key={`${keyPrefix}-t${i}`} label={text.slice(t.start, t.end)} seconds={t.seconds} />);
		last = t.end;
	});
	if (last < text.length) out.push(text.slice(last));
	return out;
}
